import Cookies from 'js-cookie'

import {
    BASIN_SESSION_ID_COOKIE_NAME,
    INSCALAR_SESSION_ID_COOKIE_NAME,
} from '@config/cookies'

export const getSessionId = (): string | undefined =>
    Cookies.get(INSCALAR_SESSION_ID_COOKIE_NAME) ??
    Cookies.get(BASIN_SESSION_ID_COOKIE_NAME)

export default getSessionId
